// First page of each juz, as stored in the Juz table (note 122 and 202).
export const JUZ_START_PAGES = [
	1, 22, 42, 62, 82, 102, 122, 142, 162, 182, 202, 222, 242, 262, 282, 302, 322, 342, 362, 382,
	402, 422, 442, 462, 482, 502, 522, 542, 562, 582,
];

export const juzForPage = (page: number) =>
	JUZ_START_PAGES.findLastIndex((start) => start <= page) + 1;
